"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emptyUserInfo = null;
exports.AdalAuthenticationContext_Empty = {
    instance: "",
    config: {},
    popUp: false,
    isAngular: false,
    REQUEST_TYPE: "UNKNOWN",
    RESPONSE_TYPE: "token",
    CONSTANTS: {},
    callback: function () { },
    login: function () { },
    loginInProgress: function () { return false; },
    getCachedToken: function (resource) { return ""; },
    getCachedUser: function () { return emptyUserInfo; },
    registerCallback: function (expectedState, resource, callback) {
        callback(null, "", "");
    },
    acquireToken: function (resource, callback) {
        callback(null, "", "");
    },
    acquireTokenPopup: function (resource, extraQueryParameters, claims, callback) {
        callback(null, "", "");
    },
    acquireTokenRedirect: function (resource, extraQueryParameters, claims) { },
    promptUser: function (urlNavigate) { },
    clearCache: function () { },
    clearCacheForResource: function (resource) { },
    logOut: function () { },
    getUser: function (callback) {
        callback(null, emptyUserInfo);
    },
    isCallback: function (hash) { return false; },
    getLoginError: function () { return ""; },
    getRequestInfo: function (hash) { return ({}); },
    saveTokenFromHash: function (requestInfo) { },
    getResourceForEndpoint: function (resource) { return ""; },
    handleWindowCallback: function (hash) { },
    log: function (level, message, error) { },
    error: function (message, error) { },
    warn: function (message) { },
    info: function (message) { },
    verbose: function (message) { },
    errorPii: function (message, error) { },
    warnPii: function (message) { },
    infoPii: function (message) { },
    verbosePii: function (message) { },
};
//# sourceMappingURL=authenticationConst.js.map